import { Component, OnInit } from '@angular/core';
import { HcaUserManagementService } from '../../../../../../shared/_services/hca-user-management.service';

@Component({
  selector: 'app-hca-user-management-list',
  templateUrl: './hca-user-management-list.component.html',
  styleUrls: ['./hca-user-management-list.component.scss']
})
export class HcaUserManagementListComponent implements OnInit {
  i: any;
  roleId: any;
  hcaUserId: number;
  public hcaAdminList = [];

  constructor(
    private hcausermanagementservice: HcaUserManagementService
  ) { }

  getAllHcaAdmins() {
    this.hcausermanagementservice.showHcaAdmins().subscribe(
      res => {
        console.log(res);
        if(res.error == 0) {
          this.hcaAdminList = res.responseObj ? res.responseObj : [];
        } else {
          this.hcaAdminList = []
        }
      }, error => {
      });
  }

  storeHcaId(id, role, i) {
    this.hcaUserId = id;
    this.roleId = role;
    this.i=i;
  }

  updateUserStatus(status) {
    this.hcausermanagementservice.changeHcaUserStatus(this.hcaUserId, status).subscribe(
      data => {
        document.getElementById('deleteModal').click();
        document.getElementById('activateModal').click();
        if(status == "Activate"){
          this.hcaAdminList[this.i].status = "Active";
        }
        else{
          this.hcaAdminList[this.i].status = "Inactive";
        }
      }, error => {
      });
  }

  ngOnInit() {
    this.getAllHcaAdmins();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-user-management/hca-user-management-list/hca-user-management-list.component.ts